<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content">
				<el-row style="display: flex">
					<el-form :inline="true" :model="searchCondition">
						<el-form-item label="姓名">
							<el-input v-model="searchCondition.name" placeholder="请输入姓名" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="searchButton" style="color: #1890ff">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<div class="table-top-box">
					<el-button size="mini" type="primary" @click="toExamine" class="operation-btn" v-if="queryData.isExamine">审核</el-button>
				</div>
				<ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" highlight-current-row @switchPaging="switchPaging">
					<el-table-column slot="first-column" align="center" prop="id" sortable label="编号">
						<template slot-scope="scope">
							{{ scope.row.id }}
						</template>
					</el-table-column>
					<el-table-column slot="first-column" align="center" prop="full_name" label="姓名">
						<template slot-scope="scope">
							{{ scope.row.user.full_name }}
						</template>
					</el-table-column>
					<el-table-column width="100" align="center" label="三方开票状态">
						<template slot-scope="scope">
							<div>{{ statusList[scope.row.status] || '未知状态' }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="征收品目">
						<template slot-scope="scope">
							<div v-for="item in JSON.parse(scope.row.detail_json)" :key="item">{{ item.name }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="项目名称">
						<template slot-scope="scope">
							<div v-for="item in JSON.parse(scope.row.detail_json)" :key="item">{{ item.projectName }}</div>
						</template>
					</el-table-column>
					<el-table-column width="100" fixed="right" align="left" label="操作">
						<template slot-scope="scope">
							<span>
								
								<el-button type="text" @click="viewApplyDetails(scope.row)" class="operation-btn" v-if="scope.row.status === 5 && scope.row.pdf_url">
									开票详情
								</el-button>
							</span>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
		<!-- 审核 -->
		<ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm" @dialogClose="examineDialogClose" :showButton="showButton">
			<template slot="content">
				<el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'">
					<el-form-item>
						<el-radio-group v-model="examineRuleForm.status" @change="selectRadio">
							<el-radio label="2">通过</el-radio>
							<el-radio label="3">驳回</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="examineRuleForm.status == 3">
						<el-input type="textarea" :rows="4" v-model="examineRuleForm.check_remark" placeholder="请输入驳回原因"></el-input>
					</el-form-item>
				</el-form>
			</template>
		</ModalDialog>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
import ModalDialog from '@/components/ModalDialog';
import ApeTable from '@/components/ApeTable';
import DatePicker from '@/components/DatePicker.vue';
import ScreeCompany from '@/components/ScreeCompany.vue';

import { mapGetters } from 'vuex';
export default {
	name: 'admin_invoice',
	components: {
		PageHeaderLayout,
		ApeTable,
		ModalDialog,
		DatePicker,
		ScreeCompany
	},

	computed: {
		...mapGetters(['userPermissions'])
	},
	watch: {
		'examineRuleForm.status': function (val) {
			if (val) {
				this.examineDialogData.loading = false;
			} else {
				this.examineDialogData.loading = true;
			}
		}
	},
	data() {
		return {
			queryData: {},
			loadingStaus: false,
			// 分页信息
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			toExamineTotal: 0,
			statusList: {
				0: '未审核',
				1: '初审通过',
				'-1': '初审未通过',
				2: '复审通过',
				'-2': '复审未通过',
				3: '支付成功',
				'-3': '支付失败',
				4: '待开票',
				'-4': '提交开票失败',
				5: '开票成功',
				'-5': '开票失败',
				6: '失效',
				'-10': '删除'
			},
			dataList: [],
			columns: [
				// {
				// 	title: '姓名',
				// 	value: 'user?.full_name',
				// 	header_align: 'center',
				// 	align: 'center'
				// },
				{
					title: '金额',
					value: 'money',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '附属信息',
					value: [
						{ label: '税局：', value: 'bm_name' },
						{ label: '证件：', value: 'id_number' },
						{ label: '付款方名称：', value: 'channel_name' },
						{ label: '账户：', value: 'bank_account_no' },
						{ label: '卡属性：', value: 'alias_card_attribute' },
						{ label: '备注：', value: 'remark' },
						// { label: "分行号：", value: "bank_line_no" },
						// { label: "支行名称：", value: "bank_branch" },
						// { label: "错误代码：", value: "error_code" },
						// { label: "错误信息：", value: "error_msg" },
						{ label: '银行渠道：', value: 'pid' }
					],
					header_align: 'center',
					width: 300
				}
			],
			searchCondition: {
				name: ''
			},
			examineDialogData: {
				visible: false,
				title: '',
				width: '40%',
				loading: true,
				modal: false
			},
			examineRuleForm: {
				id: '',
				status: '',
				check_remark: ''
			},
			showButton: ['cancel']
		};
	},
	methods: {
		//审核数据
		async invoiceAudit() {
			let args = {
				id: this.queryData.id,
				status: this.examineRuleForm.status,
				check_remark: this.examineRuleForm.check_remark
			};
			let result = this.$api.invoiceAudit(args);
			if (result) {
				this.queryData.isExamine=false
				this.$message.success('审核成功');
			} else {
				this.$message.error('审核失败');
			}
			this.initData('search');
		},
		// 处理审核模态框，确定事件
		examineHandleConfirm() {
			// 调用组件的数据验证方法
			this.invoiceAudit();
			this.examineRuleForm = {};
			this.examineDialogData.visible = false;
		},
		examineDialogClose() {
			this.examineRuleForm = {};
			this.examineDialogData.visible = false;
		},
		toExamine() {
			this.examineDialogData.title = `审核${this.queryData.id}`;
			this.examineDialogData.visible = true;
		},
		viewApplyDetails(row) {
			window.open(row.pdf_url, '_blank');
		},
		goPage(e) {
			// location.href = e;
			window.open(e, '_blank'); //新标签打开生成的pdf
		},
		//分页
		switchPaging() {
			this.initData('search');
		},
		// 搜索
		searchButton() {
			this.initData('search');
		},

		// 处理搜索条件
		handleSearchCondition() {
			return this.searchCondition;
		},
		async initData(type) {
			this.loadingStaus = true;
			let pagingInfo = this.$refs['apeTable'].getPagingInfo(type) || { current_page: 1, page_size: 10 };
			if (type == 'search') {
				pagingInfo.current_page = 1;
			}
			let searchCondition = this.handleSearchCondition();

			Object.assign(searchCondition, pagingInfo);
			let { data, pages } = await this.$api.getInvoiceLaoWuList(this.queryData.id, searchCondition);
			this.$nextTick(() => {
				this.dataList = data;
			});
			this.pagingData.total = pages.total;

			this.loadingStaus = false;
		}
	},
	mounted() {
		this.queryData = this.$route.query;
		this.initData('search');
	}
};
</script>

<style lang="scss" scoped>
.table-top-box {
	margin-bottom: 20px;
	padding-right: 30px;
	box-sizing: border-box;
	display: flex;
	justify-content: flex-end;
}
</style>
